import { UI } from 'components/_Assets/svg/Icon/ui'
import { ActionListItem } from 'components/ActionList'
import Icon from 'components/Icon'
import * as React from 'react'
import { connect, ConnectedComponent } from 'react-redux'
import { actions } from 'react-redux-form'
import { SRPRS_ENV } from '../../env'

const modalTimeout = 200

export interface ActionModalInnerComponentProps {
  value: any
  onClose: () => void
  onSave: (value: any) => void
  disableOutsideClick?: boolean
}

interface ActionListModalProps {
  value: any
  dropdown?: boolean
  onChange(val: any): void
  setModalUI(val: boolean): void
}

interface ActionListModalState {
  view: boolean
}

interface ActionListData {
  icon: JSX.Element
  subject: string | JSX.Element | ((value: any) => string | JSX.Element)
  getValue: (value: any) => JSX.Element | string
  getSubValue?: (value: any) => string | JSX.Element | undefined
  iconProps?: object
}

export function withActionListModal<T>(
  WrappedComponent:
    | ConnectedComponent<ActionModalInnerComponentProps & any, any>
    | any,
  data: ActionListData,
) {
  class ActionListModal extends React.Component<
    ActionListModalProps & T,
    ActionListModalState
  > {
    constructor(props: ActionListModalProps & T) {
      super(props)
      this.state = {
        view: false,
      }
      this.openModal = this.openModal.bind(this)
      this.closeModal = this.closeModal.bind(this)
      this.closeAndSave = this.closeAndSave.bind(this)
    }

    public openModal() {
      setTimeout(() => this.setState({ view: true }), modalTimeout)
      this.props.setModalUI(true)
    }

    public closeModal() {
      setTimeout(() => this.setState({ view: false }), modalTimeout)
      this.props.setModalUI(false)
    }

    public closeAndSave(value: any) {
      if (this.props.onChange !== undefined) {
        this.props.onChange(value)
      }
      this.closeModal()
    }

    public render() {
      return (
        <>
          <ActionListItem
            icon={data.icon}
            iconProps={data?.iconProps}
            subject={this.renderSubject()}
            value={data.getValue(this.props.value)}
            subValue={this.renderSubValue()}
            onClick={this.openModal}
            overrideEdit={
              this.props.dropdown ? <Icon icon={UI.chevronDown} /> : undefined
            }
          />
          {this.state.view ? (
            <WrappedComponent
              onClose={this.closeModal}
              onSave={this.closeAndSave}
              disableOutsideClick={SRPRS_ENV === 'editable'}
              {...this.props}
            />
          ) : null}
        </>
      )
    }

    public renderSubject(): string | JSX.Element {
      if (typeof data.subject === 'function') {
        return data.subject(this.props.value)
      }
      return data.subject
    }

    public renderSubValue() {
      if (data.getSubValue && data.getSubValue(this.props.value)) {
        return (
          <>
            {`(`}
            {data.getSubValue(this.props.value)}
            {`)`}
          </>
        )
      }
      return undefined
    }
  }

  return connect(null, dispatch => ({
    setModalUI: (val: boolean) => {
      dispatch(actions.change('ui.viewActionListModal', val))
    },
  }))(ActionListModal as any)
}
